import { trace } from 'rytm-helpers'
import SoundEvent from '../models/SoundEvent'
import SoundBankController from './SoundBankController'
import { rand, relPositionX, relPositionY } from '../lib/math_helpers'
import Pizzicato from 'pizzicato'

class SoundController {
  /**
  * SoundController class constructor  
  * @constructor
  **/
  constructor() {
    this.banks = []
    this.currentBank = false
    this.musicBank = false
    this.mouseP = {x: window.innerWidth * .5,y: window.innerHeight * .5}
    this._startBgSound()
  }
  /**
   * Add sound bank
   * @param {Array} files 
   * @param {String} path 
   */
  addSoundBanks(sndBanks) {
    sndBanks.forEach((sndObj) => {
      let sbc = new SoundBankController()
      sbc.addSoundBank(sndObj)
      switch (sbc.id) {
        case "_":
          this.musicBank = sbc
          break;
        default:
          this.banks.push(sbc)
          break;
      }
    })
  }
  /**
   * Destroy sound bank
   */
  destroySoundBanks() {
    trace("destroy sound bank")
    this.banks.forEach((bank) => {
      bank.destroySoundBank()
    })
    if (this.musicBank) {
      this.musicBank.destroySoundBank()
    }
    this.musicBank = false
    this.banks = []
    if (this._bgSound) {
      this._bgSound.stop()
      this._bgSound = null
    }
  }
  /**
   * Stop all sounds
   */
  stopAllSounds() {
    this.banks.forEach((bank) => {
      bank.stopAllSounds()
    })
    if (this.musicBank) {
      this.musicBank.stopAllSounds()
    }
    if (this._bgSound) {
      this._bgSound.stop()
    }
  }
  /**
   * Randomize sound bank
   */
  randomizeSoundBank() {
    if (this.banks.length > 0) {
      const random = this._getRandomSoundBank()
      if (random != this.currentBank) {
        // trace("switch sound bank to: ", random)
        // randomize PAN
        random.pan = (rand(0,200) - 100) * .01
        this.currentBank = random
      } else {
        return this.randomizeSoundBank()
      }
    }
  }
  /**
   * play Random music Sound
   * @return {SoundEvent} {id, time}
   */
  playRandomMusic(delay = 1) {
    let event = new SoundEvent(null, 0)
    if (this.musicBank) {
      event.id = this.musicBank.getRandomSoundId()
      event.time = this.musicBank.getSequenceRandomTimeForSnd(event.id)
      const params = {
        pitch: this._getSoundPitch()
      }
      setTimeout(() => {
        this.musicBank.stopAllSounds()
        this.musicBank.playSound(event.id, params)
      }, delay)
      
    }
    return event
  }
  /**
   * play Random sound ID
   * @return {SoundEvent} {id, time}
   */
  playRandomSound() {
    let event = new SoundEvent(null, 0)
    if (this.currentBank) {
      event.id = this.currentBank.getRandomSoundId()
      event.time = this.currentBank.getSequenceRandomTimeForSnd(event.id)
      const params = {
        pitch: this._getSoundPitch()
      }
      this.currentBank.stopAllSounds()
      this.currentBank.playSound(event.id, params)
    }
    return event
  }
  /**
   * 
   * @param {Strong} letter
   */
  playSoundByLetter(letter) {
    let event = new SoundEvent(null, 0)
    if (this.currentBank) {
      let id = this.currentBank.getRandomSoundIdForLetter(letter)
      if (id) {
        event.id = id
        event.time = this.currentBank.getSequenceRandomTimeForSnd(event.id)
        const params = {
          pitch: this._getSoundPitch()
        }
        this.currentBank.stopAllSounds()
        this.currentBank.playSound(event.id, params)
      } 
    }
    return event
  }

  onMouseDown(mouseP) {
  }
  onMouseUp(mouseP) {
  }
  onMouseMove(mouseP) {
    this.mouseP = mouseP
    this._updateBgSound()
  }

  /**
   * ### PRIVATE METHODS ###
   */
  _getRandomSoundBank() {
    return this.banks[Math.floor(Math.random() * this.banks.length)];
  }
  _getSoundPitch() {
    return 1
    // const mY = relPositionY(this.mouseP.y)
    // const f = .5
    // const pitch = (1 - mY) * f + f * 1.2
    // return pitch
  }

  _startBgSound() {
    const path = "/local/assets/2020/sounds/bgn.mp3";
    const params = {
      source: "file",
      options: {
        path,
        loop: true
      }
    }
    this._bgSound = new Pizzicato.Sound(params, () => {
      this._bgSound.play()
    })
    const reverb = new Pizzicato.Effects.Reverb({
      time: 2,
      decay: .7,
      mix: 0.6
    });
    this._bgSound.addEffect(reverb);
    this._bgSound.attack = 2
    this._bgSound.release = 1
    
  }
  _updateBgSound() {
    if (this._bgSound) {
      const mY = relPositionY(this.mouseP.y)
      const f = .7
      const pitch = (1 - mY) * f + f
      if (this._bgSound.sourceNode) {
        this._bgSound.sourceNode.playbackRate.value = pitch
      }
    }
  }



    

}

export default SoundController;
